/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Default_TitleInputs */



/**
* | output |
* | --- |
* | "Subtitles" |
*
* @param {Image_Export_Default_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_default_title = /** @type {((inputs?: Image_Export_Default_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Default_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas")
	return /** @type {LocalizedString} */ ("Subtitles")
});